import React, { useState, useEffect, useRef } from "react";
import "../css/TypewriterEffectPlayerProfile.css";

const TypewriterEffectPlayerProfile = ({ setIsLoading, clickedIndex }) => {
  const [baseHTML, setBaseHTML] = useState("");        // full layout, overview empty
  const [overviewText, setOverviewText] = useState(""); // innerHTML to type
  const containerRef = useRef(null);

  // 🔁 Your 4 full HTML blocks – kept EXACTLY as you posted
  const fullHTML = [`
    <div class="search-results">
  <div class="row mt-2">
    <div class="col-md-12">
      <div class="content-display">
        <div>
          <div class="sources">
            🔗 Sources:
            <ul>
              <li>
                <div class="source-item">
                  <a href="https://www.goldcleats.com" target="_blank" class="url">
                    <p class="description" title="GoldCleats Player App">GoldCleats Player App</p>
                  </a>
                  <a href="https://www.goldcleats.com" target="_blank" class="url"><img style="width:16px;margin-right: 4px;" src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appicon_goldcleats_48.png?crc=31052019">GoldCleats</a>
                </div>
              </li>
              <li>
              <div class="source-item">
                  <a href="https://www.transfermarkt.co.uk/cavan-sullivan/profil/spieler/1009732" target="_blank" title="Transfermarkt" class="url"><p class="description" title="Transfermarkt">Cavan Sullivan, 14, from United States.</p></a>
                  <a href="https://www.transfermarkt.co.uk/cavan-sullivan/profil/spieler/1009732" target="_blank" title="Transfermarkt" class="url"><img style="width:32px;margin-right: 2px;" src="https://tmsi.akamaized.net/head/tm_logo_rebrush.svg">Transfermarkt</a>
              </div>
            </li>
              <li>
              <div class="source-item">
                  <a href="https://www.mlssoccer.com/players/cavan-sullivan/" target="_blank" title="MLS Soccer Official Site" class="url"><p class="description" title="MLS Soccer Official Site">Official site for Major League Soccer with news, stats, and fixtures.</p></a>
                  <a href="https://www.mlssoccer.com/players/cavan-sullivan/" target="_blank" title="MLS Soccer Official Site" class="url"><img style="width:20px;margin-right: 2px;" src="https://images.mlssoccer.com/image/upload/v1736288054/assets/crest/MLS_CREST_1C_RGB_WHI_NO_BKGD_68x68_1_2_rwknik.png">MLS Soccer</a>
              </div>
            </li>
            </ul>
          </div>

          <div class="search_data">
            <div class="player_profile">👤 Player Profile:</div>
            <div class="player-profile-card mt-4 col-md-5">
              <div class="card profile-card p-3 bg-light">
                <div class="card-body">
                  <div class="d-flex justify-content-between mb-3 border-bottom-custom">
                    <div class="d-flex player-profile-header">
                      <div class="me-3">
                        <img
                          class="player-image"
                          height="64px"
                          width="64px"
                          src="https://www.goldcleats.com/gc-content/uploads/avatars/109869/MTA5ODY51625862438-bpfull.jpg"
                          onerror="this.onerror=null;this.src='https://www.goldcleats.com/gc-content/themes/goldcleats/images/avatar/mystery-man.jpg';"
                          alt=""
                        />
                      </div>
                      <div>
                        <h5 class="card-title player-name">
                          Cavan Sullivan
                          <span>
                            <img
                              class="verified_icon"
                              src="https://cdn.goldcleats.com/UI/img/ic_verified_blue.png"
                              alt="profile"
                            />
                          </span>
                        </h5>
                        <p class="card-text player-title">Professional Soccer Player</p>
                      </div>
                      <div class="">
                        <img
                          class="club-logo"
                          width="100px"
                          src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/philadelphia-union.png"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row" id="playerInfo">
                    <div class="col-sm-3">
                      <h6>Date of Birth:</h6>
                    </div>
                    <div class="col-sm-9">September 28, 2009</div>
                    <div class="col-sm-3">
                      <h6>Age Group:</h6>
                    </div>
                    <div class="col-sm-9">17-18</div>
                    <div class="col-sm-3">
                      <h6>Weight:</h6>
                    </div>
                    <div class="col-sm-9">
                      86.00 kg
                      
                    </div>
                    <div class="col-sm-3">
                      <h6>Height:</h6>
                    </div>
                    <div class="col-sm-9">
                      4.80 ft
                      
                    </div>
                    <div class="col-sm-3">
                      <h6>Main Foot:</h6>
                    </div>
                    <div class="col-sm-9">
                      Left
                      
                    </div>
                    <div class="col-sm-3">
                      <h6>Current Clubs:</h6>
                    </div>
                    <div class="col-sm-9">Philadelphia Union</div>
                    <div class="col-sm-3">
                      <h6>Playing Position:</h6>
                    </div>
                    <div class="col-sm-9">
                      <div class="player-positions-image">
                        <div class="ovalbrown CAM">
                          <span class="circle-text">CAM</span>
                        </div>
                        <img
                          src="https://www.goldcleats.com/gc-content/uploads/2023/04/player_position.png"
                          width="260"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="player_video_container">
                <div class="player_videos">🎥<span>Player Videos</span></div>
                <div class="youtube-videos">
                  <div class="video-item mb-3 position-relative">
                    <a
                      href="https://www.youtube.com/watch?v=urpvpjuT5oA"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div class="thumbnail-container">
                        <img
                          src="https://i.ytimg.com/vi/urpvpjuT5oA/mqdefault.jpg"
                          alt="GoldCleats Verified Player Highlights 1: Cavan Sullivan"
                          class="img-fluid"
                        />
                        <div class="watch-button">
                          Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                        </div>
                      </div>
                    </a>
                    <div class="player-video-title">GoldCleats Verified Player Highlights 1: Cavan Sullivan</div>
                  </div>
                  <div class="video-item mb-3 position-relative">
                    <a
                      href="https://www.youtube.com/watch?v=Te767a2zjO0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div class="thumbnail-container">
                        <img
                          src="https://i.ytimg.com/vi/Te767a2zjO0/mqdefault.jpg"
                          alt="GoldCleats Verified Player Highlights 2: Cavan Sullivan"
                          class="img-fluid"
                        />
                        <div class="watch-button">
                          Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                        </div>
                      </div>
                    </a>
                    <div class="player-video-title">GoldCleats Verified Player Highlights 2: Cavan Sullivan</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 player-overview">
              <strong>Overview of the Player:</strong>
              <p>
                Cavan Sullivan is a verified member of the GoldCleats community. He is an American professional soccer
                player who plays as a midfielder for the Philadelphia Union in Major League Soccer (MLS).
              </p>
              <strong>Birth and Early Life:</strong>
              <p>
                Cavan was born on September 28, 2009, in Philadelphia, Pennsylvania. He is of German-Bangladeshi descent
                through his mother. He joined the Philadelphia Union youth academy in 2020.
              </p>
              <strong>Club Career Milestones:</strong>
              <p>
                On March 24, 2024, Sullivan made his professional debut for Philadelphia Union II in an MLS Next Pro
                match, providing an assist in a 2–1 victory. He signed a homegrown contract with the Philadelphia Union
                on May 9, 2024, until 2028, making him the fifth-youngest player to sign a first-team contract in MLS
                history.
              </p>
              <strong>Professional Debut and Significant Matches:</strong>
              <p>
                Sullivan made his MLS debut on July 17, 2024, at 14 years and 293 days old, becoming the youngest player
                to appear in a league match for a major professional league in the U.S., breaking Freddy Adu's record.
                He also played in the MLS Next All-Star Game on July 23, 2024, where he was named the most valuable
                player.
              </p>
              <strong>International Career Highlights:</strong>
              <p>
                Sullivan is eligible to represent Germany, the United States, and Bangladesh. He has represented the
                U.S. at the youth level, helping the U15 team win the 2023 CONCACAF Boys' Under-15 Championship.
              </p>
              <strong>Playing Style and Position:</strong>
              <p>Sullivan primarily operates as a midfielder and is known for his vision and left-footed play.</p>
              <strong>Family Background:</strong>
              <p>
                Cavan is the youngest of four children in a soccer-oriented family. His father, Brendan, played
                professionally in the A-League, and his mother, Heike, played Division I soccer. His brother, Quinn,
                plays for the Philadelphia Union's first team, while his other brothers are also involved in soccer.
              </p>
              <strong>Recent Achievements and Awards:</strong>
              <p>
                He was part of the United States U15 team that won the CONCACAF Under-15 Championship in 2023.
              </p>
              <strong>Future Plans or Transfers:</strong>
              <p>
                His contract with the Philadelphia Union includes a transfer clause to Manchester City once he turns 18,
                with potential loan destinations in Europe if he develops rapidly.
              </p>
              <div class="row"><div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.philadelphiaunion.com/news/cavan-sullivan-makes-history-under-the-lights-of-subaru-park"><img
              src="https://images.mlssoccer.com/image/private/t_editorial_landscape_12_desktop/f_auto/mls-phi/gpoxvqjfjfhdxogkgjfv.jpg"
              class="img-fluid" style="border-radius: 5px;" alt="Cavan Sullivan"/>
              </a>
              </div>
              <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://mlssoccer.com/news/philadelphia-union-introduce-generational-talent-cavan-sullivan"><img
              src="https://d2u1z1lopyfwlx.cloudfront.net/thumbnails/697c004b-d61e-5a23-879f-6ab56bc7dc76/8c35e1cd-09b7-56ce-8d7a-da2365cfa0ce.jpg" class="img-fluid" style="border-radius: 5px;"
              alt="Cavan Sullivan"/>
              </a>
              </div>
              <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.today.com/news/sports/youngest-player-mls-cavan-sullivan-philadelphia-union-rcna162532"><img
              src="https://d2u1z1lopyfwlx.cloudfront.net/thumbnails/b4dd19b4-3332-5f8b-913c-ff73caf327e2/93ffe97e-e899-576f-9b72-1d54099b6924.jpg" class="img-fluid" style="border-radius: 5px;height: 125px;" alt="Cavan Sullivan"/>
              </a>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
    `
<div class="search-results">
  <div class="row mt-2">
    <div class="col-md-12">
      <div class="content-display">
        <div>         
          <div class="sources">
           🔗 Sources:
            <ul>
              <li>
                <div class="source-item">
                  <a
                    href="https://www.goldcleats.com/?usernicename=judewellings&userType=1&type=1"
                    target="_blank"
                    class="url"
                  >
                    <p
                      class="description"
                      title="GoldCleats Player App"
                    >
                      GoldCleats Player App
                    </p>
                  </a>
                  <a href="https://www.goldcleats.com/?usernicename=judewellings&userType=1&type=1" target="_blank" class="url">
                    <img style="width:16px;margin-right: 4px;" src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appicon_goldcleats_48.png?crc=31052019">GoldCleats.com
                  </a>
                </div>
              </li>

              <li>
        <div class="source-item">
            <a href="https://www.transfermarkt.co.uk/jude-wellings/profil/spieler/943909" target="_blank" title="Transfermarkt" class="url"><p class="description" title="Transfermarkt">Jude Wellings, Real Salt Lake City, MLS, United States</p></a>
            <a href="https://www.transfermarkt.co.uk/jude-wellings/profil/spieler/943909" target="_blank" title="Transfermarkt" class="url"><img style="width:32px;margin-right: 2px;" src="https://tmsi.akamaized.net/head/tm_logo_rebrush.svg">Transfermarkt</a>
        </div>
    </li>
    <li>
        <div class="source-item">
            <a href="https://www.mlssoccer.com/players/jude-wellings/" target="_blank" title="MLS Soccer Official Site" class="url"><p class="description" title="MLS Soccer Official Site">Official site for Major League Soccer with news, stats, and fixtures.</p></a>
            <a href="https://www.mlssoccer.com/players/jude-wellings/" target="_blank" title="MLS Soccer Official Site" class="url"><img style="width:20px;margin-right: 2px;" src="https://images.mlssoccer.com/image/upload/v1736288054/assets/crest/MLS_CREST_1C_RGB_WHI_NO_BKGD_68x68_1_2_rwknik.png">MLS Soccer</a>
        </div>
    </li>
            </ul>
          </div>

         
          <div class="search_data">
            <div class="player_profile">
              👤<span>Player Profile:</span>
            </div>
            <div class="player-profile-card mt-4 col-md-5">
              <div class="card profile-card p-3 bg-light">
                <div class="card-body">
                  <div
                    class="d-flex justify-content-between mb-3 border-bottom-custom"
                  >
                    <div class="d-flex">
                      <div class="me-3">
                        <img
                          class="player-image"
                          height="64px"
                          width="64px"
                          src="https://www.goldcleats.com/gc-content/uploads/avatars/108744/MTA4NzQ01641071210-bpfull.jpg"
                          onerror="this.onerror=null;this.src='https://www.goldcleats.com/gc-content/themes/goldcleats/images/avatar/mystery-man.jpg';"
                          alt=""
                        />
                      </div>
                      <div>
                        <h5 class="card-title player-name">
                          Jude Wellings
                          <span>
                            <img
                              class="verified_icon"
                              src="https://cdn.goldcleats.com/UI/img/ic_verified_blue.png"
                              alt="profile"
                            />
                          </span>
                        </h5>
                        <p class="card-text player-title">Midfielder</p>
                      </div>
                           <div class="">
                      <img
                        class="club-logo"
                        width="100px"
                        src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/real-salt-lake-city.png"
                        alt=""
                      />
                    </div>
                    </div>
                  </div>

                 
                  <div class="row" id="playerInfo">
                    <div class="col-sm-3">
                      <h6>Date of Birth:</h6>
                    </div>
                    <div class="col-sm-9">April 26, 2006</div>

                    <div class="col-sm-3">
                      <h6>Age Group:</h6>
                    </div>
                    <div class="col-sm-9">13-14</div>

                    <div class="col-sm-3">
                      <h6>Weight:</h6>
                    </div>
                    <div class="col-sm-9">
                      126.00 lbs
                     
                    </div>

                    <div class="col-sm-3">
                      <h6>Height:</h6>
                    </div>
                    <div class="col-sm-9">
                      5.70 ft
                      
                    </div>

                    <div class="col-sm-3">
                      <h6>Main Foot:</h6>
                    </div>
                    <div class="col-sm-9">
                      Right
                     
                    </div>

                    <div class="col-sm-3">
                      <h6>Current Club:</h6>
                    </div>
                    <div class="col-sm-9">Real Salt Lake</div>                

                    <div class="col-sm-3">
                      <h6>Playing Position:</h6>
                    </div>
                    <div class="col-sm-9">
                      <div class="player-positions-image">
                        <div class="ovalbrown DM">
                          <span class="circle-text">DM</span>
                        </div>
                        <div class="ovalbrown LCM">
                          <span class="circle-text">LCM</span>
                        </div>
                        <div class="ovalbrown RCM">
                          <span class="circle-text">RCM</span>
                        </div>
                        <div class="ovalbrown CAM">
                          <span class="circle-text">CAM</span>
                        </div>
                        <img
                          src="https://www.goldcleats.com/gc-content/uploads/2023/04/player_position.png"
                          width="260"
                          alt="Player Position"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            <div class="player_video_container">
            <div class="player_videos">🎥<span>Player Videos</span></div>
            <div class="youtube-videos">
              <div class="video-item mb-3 position-relative">
                <a href="https://www.youtube.com/watch?v=OrnwWqxFcY8" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://i.ytimg.com/vi/OrnwWqxFcY8/mqdefault.jpg" 
                        alt="GoldCleats Verified Player Highlights: Jude Wellings" 
                        class="img-fluid">
                    <div class="watch-button">
                      Watch
                      <span class="circle-icon">
                        <i class="fa fa-play"></i>
                      </span>
                    </div>
                  </div>
                  <div class="player-video-title">
                    GoldCleats Verified Player Highlights: Jude Wellings
                  </div>
                </a>
              </div>

              <div class="video-item mb-3 position-relative">
                <a href="https://www.youtube.com/watch?v=g0xIDirq9sw" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://i.ytimg.com/vi/g0xIDirq9sw/mqdefault.jpg" 
                        alt="Homegrown Signing Jude Wellings - Real Salt Lake. MLS Next All Star standout 🚀" 
                        class="img-fluid">
                    <div class="watch-button">
                      Watch
                      <span class="circle-icon">
                        <i class="fa fa-play"></i>
                      </span>
                    </div>
                  </div>
                  <div class="player-video-title">
                    Homegrown Signing Jude Wellings - Real Salt Lake.
                  </div>
                </a>
              </div>
            </div>
            <div class="video-data mt-1 goldcleats-videos" style="display:flex;">
              <div class="video-data-item mb-3 position-relative right-side-bar">
                <a href="https://www.goldcleats.com/?type=public&amp;item_id=12138&amp;action=34" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://www.goldcleats.com/gc-content/uploads/video/vimeo/560229059/1158079871_640x640.jpg" alt="Video 1603" class="img-fluid">
                    <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span></div>
                  </div>
                  <div class="mt-2">
                    <span class="goldcleats-icon">
                      <img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg">
                    </span>
                    <span class="player-video-title">GoldCleats Player Profile Video</span>
                  </div>
                </a>
              </div>

              <div class="video-data-item mb-3 position-relative right-side-bar">
                <a href="https://www.goldcleats.com/?type=public&amp;item_id=10036&amp;action=34" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://www.goldcleats.com/gc-content/uploads/video/vimeo/439409380/926108122_640x640.jpg" alt="Video 2142" class="img-fluid">
                    <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span></div>
                  </div>
                  <div class="mt-2">
                    <span class="goldcleats-icon">
                      <img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg">
                    </span>
                   <span class="player-video-title">GoldCleats Player Profile Video</span>
                  </div>
                </a>
              </div>
          
          </div>
          </div>

            </div>
             
            <div class="col-md-7 player-overview">
          
            <strong>Overview of the Player:</strong>
            <p>
              Jude Wellings is a verified member of the GoldCleats community. He
              is an American professional soccer player who plays as a
              midfielder for Major League Soccer club Real Salt Lake. Born on
              April 26, 2006, he has quickly made a name for himself in the
              youth soccer circuit.
            </p>

            <strong>Birth and Early Life:</strong>
            <p>
              Jude was born in the United States and began his soccer journey at
              a young age, showcasing his talent in various youth leagues
              before joining the Real Salt Lake academy.
            </p>

            <strong>Club Career Milestones:</strong>
            <p>
              Wellings joined the Real Salt Lake academy in the summer of 2020.
              He captained the under-15 team that won the 2021 MLS NEXT Cup and
              later transitioned to the under-17 level, where he scored five
              goals and provided two assists in 12 appearances. His performance
              earned him the title of MLS NEXT Best Player of the Tournament.
            </p>

            <strong>Professional Debut and Significant Matches:</strong>
            <p>
              Jude made his professional debut with Real Monarchs, Real Salt
              Lake's USL Championship affiliate, as a substitute in a match
              against Rio Grande Valley FC on October 27, 2021.
            </p>

            <strong>International Career Highlights:</strong>
            <p>
              As of now, there are no recorded international appearances for
              Jude Wellings, but his youth career suggests a promising future
              on the international stage.
            </p>

            <strong>Playing Style and Position:</strong>
            <p>
              Wellings is known for his versatility in midfield, capable of
              playing as a defensive midfielder (DM), left center midfielder
              (LCM), right center midfielder (RCM), and attacking midfielder
              (CAM). His right-footed play adds to his effectiveness in various
              roles.
            </p>

            <strong>Family Background:</strong>
            <p>
              Details about Jude's family background are not extensively
              documented, but his support system has been crucial in his
              development as a player.
            </p>

            <strong>Recent Achievements and Awards:</strong>
            <p>
              Jude has garnered attention for his performances in youth
              tournaments, particularly his recognition as the MLS NEXT Best
              Player of the Tournament.
            </p>

            <strong>Future Plans or Transfers:</strong>
            <p>
              Jude signed a homegrown player deal with Real Salt Lake on January
              10, 2022, which runs through 2025, with an option to extend to
              2026. His future in the club looks promising as he continues to
              develop his skills.
            </p>

            <strong>Video Views:</strong>
            <p>
              Jude has garnered 2,946 video views on the GoldCleats community,
              indicating a growing interest in his career.
            </p>

            <div class="row"><div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.rsl.com/news/real-salt-lake-signs-jude-wellings-to-homegrown-contract"><img
              src="https://images.mlssoccer.com/image/private/t_q-best/mls-rsl-prd/dflcoiz70npf0smnwo8j.png"
              class="img-fluid" style="border-radius: 5px;" alt="Jude Wellings"/>
              </a>
              </div>
              <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.rsl.com/players/jude-wellings/news/"><img
              src="https://images.mlssoccer.com/image/private/t_editorial_landscape_8_desktop_mobile/f_auto/mls-rsl-prd/dpql8vsbvg1w2tg2fpij" class="img-fluid" style="border-radius: 5px;" alt="Jude Wellings"/>
              </a>
              </div>
               <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.mlssoccer.com/news/real-salt-lake-sign-jude-wellings-as-homegrown-player"><img
              src="https://images.mlssoccer.com/image/private/t_q-best/prd-league/ge914oyksiwqhzotnxuh.jpg" class="img-fluid" style="border-radius: 5px;" alt="Jude Wellings"/>
              </a>
              </div>

               </div>

          </div>
        </div>
      </div>
    </div>
     </div
    
  </div>
</div>
`,
    `
<div class="search-results">
    <div class="row mt-2">
        <div class="col-md-12">
            <div class="content-display">
                <div>
                    <div class="sources">
                       🔗 Sources:
                        <ul>
                            <li>
                                <div class="source-item">
                                    <a href="https://www.goldcleats.com/?usernicename=nimfashaberchimas1&userType=1&type=1" target="_blank" class="url">
                                        <p class="description" title="GoldCleats Player App">GoldCleats Player
                                            App</p>
                                    </a>
                                    <a href="https://www.goldcleats.com/?usernicename=nimfashaberchimas1&userType=1&type=1" target="_blank" class="url"><img style="width:16px;margin-right: 4px;" src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appicon_goldcleats_48.png?crc=31052019">GoldCleats</a>
                                </div>
                            </li>
                             <li>
                            <div class="source-item">
                                <a href="https://www.transfermarkt.co.uk/nimfasha-berchimas/profil/spieler/1000273" target="_blank" title="transfermarkt" class="url"><p class="description" title="transfermarkt">Nimfasha Berchimas,Charlotte FC,MLS,United States</p></a>
                                <a href="https://www.transfermarkt.co.uk/nimfasha-berchimas/profil/spieler/1000273" target="_blank" title="transfermarkt" class="url"><img style="width:32px;margin-right: 2px;" src="https://tmsi.akamaized.net/head/tm_logo_rebrush.svg">Transfermarkt</a>
                            </div>
                        </li>
                        <li>
                            <div class="source-item">
                                <a href="https://www.mlssoccer.com/players/nimfasha-berchimas/" target="_blank" title="MLS Soccer Official Site" class="url"><p class="description" title="MLS Soccer Official Site">Official site for Major League Soccer with news, stats, and fixtures.</p></a>
                                <a href="https://www.mlssoccer.com/players/nimfasha-berchimas/" target="_blank" title="MLS Soccer Official Site" class="url"><img style="width:20px;margin-right: 2px;" src="https://images.mlssoccer.com/image/upload/v1736288054/assets/crest/MLS_CREST_1C_RGB_WHI_NO_BKGD_68x68_1_2_rwknik.png">MLS Soccer</a>
                            </div>
                        </li>
                        </ul>
                    </div>

                    <div class="search_data">
                        <div class="player_profile">👤<span>Player Profile:</span></div>
                        <div class="player-profile-card mt-4 col-md-5">
                            <div class="card profile-card p-3 bg-light">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between mb-3 border-bottom-custom">
                                        <div class="d-flex">
                                            <div class="me-3">
                                                <img class="player-image" height="64px" width="64px" src="https://www.goldcleats.com/gc-content/uploads/avatars/112859/MTEyODU51647395829-bpfull.jpg" onerror="this.onerror=null;this.src='https://www.goldcleats.com/gc-content/themes/goldcleats/images/avatar/mystery-man.jpg';" alt="">
                                            </div>
                                            <div>
                                                <h5 class="card-title player-name">Nimfasha Berchimas
                                                    <span><img class="verified_icon" src="https://cdn.goldcleats.com/UI/img/ic_verified_blue.png" alt="profile"></span>
                                                </h5>
                                                <p class="card-text player-title">Professional Soccer Player</p>
                                            </div>
                                             <div class="">
                                              <img
                                                class="club-logo"
                                                width="100px"
                                                src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/Charlotte_FC.png"
                                                alt=""
                                              />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" id="playerInfo">
                                        <div class="col-sm-3">
                                            <h6>Date of Birth:</h6>
                                        </div>
                                        <div class="col-sm-9">February 22, 2008</div>
                                        <div class="col-sm-3">
                                            <h6>Age Group:</h6>
                                        </div>
                                        <div class="col-sm-9">13-14</div>
                                        <div class="col-sm-3">
                                            <h6>Weight:</h6>
                                        </div>
                                        <div class="col-sm-9">138.00 lbs
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Height:</h6>
                                        </div>
                                        <div class="col-sm-9">5.70 ft 
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Main Foot:</h6>
                                        </div>
                                        <div class="col-sm-9">Right 
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Current Clubs:</h6>
                                        </div>
                                        <div class="col-sm-9">Charlotte FC</div>                                      
                                       
                                        <div class="col-sm-3">
                                            <h6>Playing Position:</h6>
                                        </div>
                                        <div class="col-sm-9">
                                            <div class="player-positions-image">
                                                <div class="ovalbrown LF"><span class="circle-text">LF</span></div>
                                                <div class="ovalbrown CF"><span class="circle-text">CF</span></div>
                                                <div class="ovalbrown LM"><span class="circle-text">LM</span></div><img src="https://www.goldcleats.com/gc-content/uploads/2023/04/player_position.png" width="260">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
<div class="player_video_container">
   
            <div class="player_videos">🎥<span>Player Videos</span></div>
            <div class="youtube-videos">
                <div class="video-item mb-3 position-relative"><a href="https://www.youtube.com/watch?v=r28mR-0yG8E"
                        target="_blank" rel="noopener noreferrer">
                        <div class="thumbnail-container"><img src="https://i.ytimg.com/vi/r28mR-0yG8E/mqdefault.jpg" alt="GoldCleats Verified Player Highlights: Nimfasha Berchimas" class="img-fluid">
                            <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                            </div>
                        </div>
                        <div class="player-video-title">GoldCleats Verified Player Highlights: Nimfasha Berchimas</div>
                    </a>
                </div>
                <div class="video-item mb-3 position-relative"><a href="https://www.youtube.com/watch?v=mYn35lRcNnM"
                        target="_blank" rel="noopener noreferrer">
                        <div class="thumbnail-container"><img src="https://i.ytimg.com/vi/mYn35lRcNnM/mqdefault.jpg" alt="GoldCleats Verified Player Highlights: Nimfasha Berchimas" class="img-fluid">
                            <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                            </div>
                        </div>
                        <div class="player-video-title">GoldCleats Verified Player Highlights: Nimfasha Berchimas</div>
                    </a>
                  </div>
            </div>


            <div class="video-data mt-1 goldcleats-videos" style="display:flex;">
              <div class="video-data-item mb-3 position-relative right-side-bar">
                <a href="https://www.goldcleats.com/?type=public&amp;item_id=13500&amp;action=34" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://www.goldcleats.com/gc-content/uploads/video/vimeo/692333484/1401232103-78105708494478588525661383df7ba35ce9a9d042b008777cafa46c496f1450-d_640x360.jpg" alt="Video 1603" class="img-fluid">
                    <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span></div>
                  </div>
                  <div class="mt-2">
                    <span class="goldcleats-icon">
                      <img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg">
                    </span>
                    <span class="player-video-title">GoldCleats Player Profile Video</span>
                  </div>
                </a>
              </div>

              <div class="video-data-item mb-3 position-relative right-side-bar">
                <a href="https://www.goldcleats.com/?type=public&amp;item_id=13501&amp;action=34" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img src="https://www.goldcleats.com/gc-content/uploads/video/vimeo/692333980/1401232819-327b482879ee8333da2826a3fdaf77b1ede71987ca172e285bfb0d7a790bc11e-d_640x360.jpg" alt="Video 2142" class="img-fluid">
                    <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span></div>
                  </div>
                  <div class="mt-2">
                    <span class="goldcleats-icon">
                      <img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg">
                    </span>
                   <span class="player-video-title">GoldCleats Player Profile Video</span>
                  </div>
                </a>
              </div>
          
          </div>
           
        </div>

</div>

<div class="col-md-7 player-overview">
                        <strong>Overview of the Player:</strong>
                        <p>Nimfasha Berchimas is a verified member of the GoldCleats community. He is a promising young
                            talent in professional soccer, currently playing as a winger or forward for Major League
                            Soccer club Charlotte FC. Born in Burundi and raised in the United States, he has quickly
                            made a name for himself in both club and international competitions.</p>

                        <strong>Birth and Early Life:</strong>
                        <p>Nimfasha Berchimas was born on February 22, 2008, in Burundi. He moved to the United States
                            as a child and settled in High Point, North Carolina, where he began his soccer journey.</p>

                        <strong>Club Career Milestones:</strong>
                        <p>Berchimas started his soccer career with local side NC Fusion before signing with Charlotte
                            FC in 2020. He made headlines in November 2022 when he signed a homegrown contract with
                            Charlotte FC at just 14 years and 268 days old, making him the sixth-youngest player in MLS
                            history to sign professionally. In the 2023 season, he played eight matches with Charlotte's
                            MLS Next Pro reserve team, Crown Legacy FC.</p>

                        <strong>Professional Debut and Significant Matches:</strong>
                        <p>On February 24, 2024, Berchimas made his senior MLS debut for Charlotte FC in a 1–0 victory
                            against New York City FC, becoming the 9th youngest player in MLS history to make a senior
                            appearance.</p>

                        <strong>International Career Highlights:</strong>
                        <p>Berchimas has represented the United States at the under-15 and under-16 levels. He was
                            called up to the under-17 national team for the 2023 FIFA U-17 World Cup, where he made a
                            significant impact by scoring two goals in the opening match against South Korea. This
                            achievement made him the youngest player to score for the United States at an U-17 World Cup
                            since Freddy Adu in 2003. He continued his impressive form by scoring in the match against
                            Burkina Faso, placing him joint-first in the tournament's goal-scoring chart.</p>

                        <strong>Playing Style and Position:</strong>
                        <p>Berchimas is known for his agility and speed on the field, making him a versatile winger and
                            forward. His ability to create scoring opportunities and contribute to the team's offensive
                            play has been a key aspect of his game.</p>

                        <strong>Family Background:</strong>
                        <p>Details about Berchimas's family background are limited, but his journey from Burundi to the
                            United States reflects a supportive environment that has fostered his soccer talent.</p>

                        <strong>Recent Achievements and Awards:</strong>
                        <p>His recent performances in the U-17 World Cup and his rapid rise in the MLS have garnered
                            attention, positioning him as a player to watch in the coming years.</p>

                        <strong>Future Plans or Transfers:</strong>
                        <p>As of now, Berchimas remains focused on his development at Charlotte FC and his contributions
                            to the U.S. youth national teams. His future in professional soccer looks promising, with
                            expectations for continued growth and potential transfers as he matures in his career.</p>

                        <div class="row"><div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.goal.com/en-us/lists/weekly-wonderkid-nimfasha-berchimas-charlotte-fc-usmnt/blt73d6800be9808d81"><img
                        src="https://assets.goal.com/images/v3/blt44bbb98d09fda356/berchimas.jpg?auto=webp&format=pjpg&width=3840&quality=60"
                        class="img-fluid" style="border-radius: 5px;" alt="Nimfasha Berchimas"/>
                        </a>
                        </div>
                        <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.charlottefootballclub.com/news/charlotte-fc-signs-academy-product-nimfasha-berchimas-to-homegrown-contract"><img
                        src="https://images.mlssoccer.com/image/private/t_photogallery/mls-clt-prd/ysbytfijenfgcrkirlzt.jpg" class="img-fluid" style="border-radius: 5px; height: 125px;" alt="Nimfasha Berchimas"/>
                        </a>
                        </div>
                         <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.thecharlottepost.com/news/2023/11/17/qcfc/charlotte-fc-s-nimfasha-berchimas-makes-a-name-for-himself/"><img
                        src="https://www.thecharlottepost.com/clientuploads/v50n11photos/Berchimas-CLTFC.jpg" class="img-fluid" style="border-radius: 5px; height: 125px;" alt="Nimfasha Berchimas"/>
                        </a>
                        </div>
                         </div>

                    </div>
                </div>
            </div>
           
        </div>
         </div>
    </div>
</div>`,
    `
<div class="search-results">
    <div class="row mt-2">
        <div class="col-md-12">
            <div class="content-display">
                <div>
                    <div class="sources">
                       🔗 Sources:
                        <ul>
                            <li>
                                <div class="source-item">
                                    <a href="https://www.goldcleats.com/?usernicename=alexalcala&userType=1&type=1" target="_blank" class="url">
                                        <p class="description" title="Profile information about Alex Alcala">Profile
                                            information about Alex Alcala</p>
                                    </a>
                                    <a href="https://www.goldcleats.com/?usernicename=alexalcala&userType=1&type=1" target="_blank" class="url"><img style="width:16px;margin-right: 4px;" src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/player/appicon_goldcleats_48.png?crc=31052019">GoldCleats Player App</a>
                                </div>
                            </li>

                             <li>
                              <div class="source-item">
                                  <a href="https://www.transfermarkt.co.uk/alex-alcala/profil/spieler/838925" target="_blank" title="transfermarkt" class="url"><p class="description" title="transfermarkt">Álex Alcalá, Manchester City U23, Premier League 2, Mexico</p></a>
                                  <a href="https://www.transfermarkt.co.uk/alex-alcala/profil/spieler/838925" target="_blank" title="transfermarkt" class="url"><img style="width:32px;margin-right: 2px;" src="https://tmsi.akamaized.net/head/tm_logo_rebrush.svg">Transfermarkt</a>
                              </div>
                          </li>
                          <li>
                              <div class="source-item">
                                  <a href="https://www.mlssoccer.com/players/alex-alcala/" target="_blank" title="MLS Soccer Official Site" class="url"><p class="description" title="MLS Soccer Official Site">Official site for Major League Soccer with news, stats, and fixtures.</p></a>
                                  <a href="https://www.mlssoccer.com/players/alex-alcala/" target="_blank" title="MLS Soccer Official Site" class="url"><img style="width:20px;margin-right: 2px;" src="https://images.mlssoccer.com/image/upload/v1736288054/assets/crest/MLS_CREST_1C_RGB_WHI_NO_BKGD_68x68_1_2_rwknik.png">MLS Soccer</a>
                              </div>
                          </li>
                        </ul>
                       
                    </div>

                    <div class="search_data">
                        <div class="player_profile">👤<span>Player Profile:</span></div>
                        <div class="player-profile-card mt-4 col-md-5">
                            <div class="card profile-card p-3 bg-light">
                                <div class="card-body">
                                    <div class="d-flex justify-content-between mb-3 border-bottom-custom">
                                        <div class="d-flex">
                                            <div class="me-3">
                                                <img class="player-image" height="64px" width="64px" src="https://www.goldcleats.com/gc-content/uploads/avatars/113016/MTEzMDE21650399700-bpfull.jpg" onerror="this.onerror=null;this.src='https://www.goldcleats.com/gc-content/themes/goldcleats/images/avatar/mystery-man.jpg';" alt="">
                                            </div>
                                            <div>
                                                <h5 class="card-title player-name">Alex Alcalá
                                                    <span><img class="verified_icon" src="https://cdn.goldcleats.com/UI/img/ic_verified_blue.png" alt="profile"></span>
                                                </h5>
                                                <p class="card-text player-title">Professional Footballer</p>
                                            </div>
                                             <div class="">
                                              <img
                                                class="club-logo"
                                                width="100px"
                                                src="https://www.goldcleats.com/gc-content/themes/goldcleats/UI/img/clubs/manchester_city_fc.png"
                                                alt=""
                                              />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" id="playerInfo">
                                        <div class="col-sm-3">
                                            <h6>Date of Birth:</h6>
                                        </div>
                                        <div class="col-sm-9">20 October 2005</div>
                                        <div class="col-sm-3">
                                            <h6>Age Group:</h6>
                                        </div>
                                        <div class="col-sm-9">15-16</div>
                                        <div class="col-sm-3">
                                            <h6>Weight:</h6>
                                        </div>
                                        <div class="col-sm-9">122.00 lbs 
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Height:</h6>
                                        </div>
                                        <div class="col-sm-9">5.40 ft 
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Main Foot:</h6>
                                        </div>
                                        <div class="col-sm-9">Left 
                                        </div>
                                        <div class="col-sm-3">
                                            <h6>Current Clubs:</h6>
                                        </div>
                                        <div class="col-sm-9">Manchester City</div>
                                        <div class="col-sm-3">
                                            <h6>Playing Position:</h6>
                                        </div>
                                        <div class="col-sm-9">
                                            <div class="player-positions-image">
                                                <div class="ovalbrown CAM"><span class="circle-text">CAM</span></div>
                                                <img src="https://www.goldcleats.com/gc-content/uploads/2023/04/player_position.png" width="260">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="player_video_container">
                               
            <div class="player_videos">🎥<span>Player Videos</span></div>
            <div class="youtube-videos">
                <div class="video-item mb-3 position-relative"><a href="https://www.youtube.com/watch?v=f5qpc3rLoao"
                        target="_blank" rel="noopener noreferrer">
                        <div class="thumbnail-container"><img src="https://i.ytimg.com/vi/f5qpc3rLoao/mqdefault.jpg" alt="GoldCleats Verified Player Highlights: Alex Alcala" class="img-fluid">
                            <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                            </div>
                        </div>
                        <div class="player-video-title">GoldCleats Verified Player Highlights: Alex Alcala</div>
                    </a>
                </div>
                <div class="video-item mb-3 position-relative"><a href="https://www.youtube.com/watch?v=l3zamzeAXd0"
                        target="_blank" rel="noopener noreferrer">
                        <div class="thumbnail-container"><img src="https://i.ytimg.com/vi/l3zamzeAXd0/mqdefault.jpg" alt="GoldCleats Verified Player: Alex Alcala Highlights" class="img-fluid">
                            <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span>
                            </div>
                        </div>
                         <div class="player-video-title">GoldCleats Verified Player: Alex Alcala Highlights</div>
                    </a>
                </div>
            </div>

            <div class="video-data mt-1 goldcleats-videos">
              <div class="video-data-item mb-3 position-relative right-side-bar">
                <a href="https://www.goldcleats.com/?type=public&amp;item_id=13617&amp;action=34" target="_blank" rel="noopener noreferrer">
                  <div class="thumbnail-container">
                    <img style="width: 100%;" src="https://www.goldcleats.com/gc-content/uploads/video/vimeo/700991547/1416797276-86d116f0bd7db747621ac47e5f4ea158e73badf66706cdaa5b9eef8850a09dc1-d_640x360.jpg" alt="Video 1603" class="img-fluid">
                    <div class="watch-button">Watch<span class="circle-icon"><i class="fa fa-play"></i></span></div>
                  </div>
                  <div class="mt-2">
                    <span class="goldcleats-icon">
                      <img src="https://www.goldcleats.com/signature/appicon_goldcleats_128.jpg">
                    </span>
                    <span class="player-video-title">GoldCleats Player Profile Video</span>
                  </div>
                </a>
              </div>

           
          
          </div>

             </div>
                        </div>
                <div class="col-md-7 player-overview">
                        <strong>Overview of the Player:</strong>
                        <p>Alex Alcalá is a verified member of the GoldCleats community. He is a professional footballer
                            who plays as a midfielder for Manchester City in the Premier League. Born in the United
                            States, he is also a youth international for Mexico.</p>

                        <strong>Birth and Early Life:</strong>
                        <p>Born in Stockton, California, on 20 October 2005, Alcalá began his football journey at a
                            young age, showcasing his talent in local clubs.</p>

                        <strong>Club Career Milestones:</strong>
                        <p>Alcalá started his career with Stockton TLJ FC Rebels and trained with prestigious clubs like
                            Manchester City, Barcelona, and Pachuca before joining the LA Galaxy academy in 2020. He
                            signed professional terms with LA Galaxy in February 2021. In July 2021, Manchester City
                            secured a pre-arrangement for Alcalá's buyout clause upon turning 18. He was named to the
                            MLS Next All-Star Game in July 2022.</p>

                        <strong>Manchester City:</strong>
                        <p>On 11 January 2024, Alcalá signed a five-year deal with Manchester City's Elite Development
                            Squad, marking a significant step in his professional career.</p>

                        <strong>International Career Highlights:</strong>
                        <p>Eligible to represent both Mexico and the United States, Alcalá has been capped by Mexico at
                            various youth levels, contributing to his development as a player.</p>

                        <strong>Playing Style and Position:</strong>
                        <p>Alcalá is known for his skillful and fast playing style, often drawing comparisons to
                            Brazilian legend Ronaldinho. He has been referred to as the "Mexican Messi" due to his
                            stature and playing style, although he prefers to carve out his own identity in the sport.
                        </p>

                        <strong>Family Background:</strong>
                        <p>Details about Alcalá's family background are not extensively documented, but his early life
                            in California played a crucial role in shaping his football career.</p>

                        <strong>Recent Achievements and Awards:</strong>
                        <p>Alcalá's recent recognition includes being named to the MLS Next All-Star Game and securing a
                            professional contract with Manchester City.</p>

                        <strong>Future Plans or Transfers:</strong>
                        <p>As of now, Alcalá is focused on his development within Manchester City's Elite Development
                            Squad, with aspirations for a future first-team debut.</p>

                        <div class="row"><div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.lagalaxy.com/news/la-galaxy-ii-sign-midfielder-alex-alcala"><img
                        src="https://images.mlssoccer.com/image/private/t_editorial_landscape_12_desktop/mls-lag-prd/uqgaar2s87e4punpbhkh.jpg"
                        class="img-fluid" style="border-radius: 5px;" alt="Alex Alcalá"/>
                        </a>
                        </div>
                        <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.manchestereveningnews.co.uk/sport/football/transfer-news/who-alex-alcala-man-citys-28460241"><img
                        src="https://i2-prod.manchestereveningnews.co.uk/incoming/article28461611.ece/ALTERNATES/s1200b/0_Screenshot-2024-01-17-at-120339.png" class="img-fluid" style="border-radius: 5px; height: 125px;" alt="Alex Alcalá"/>
                        </a>
                        </div>
                          <div class="col-md-4 col-12 mb-3"><a target="_blank" href="https://www.goal.com/en-in/lists/man-city-la-galaxy-alex-alcala-city-football-group/bltf4793f5615cba92d"><img
                        src="https://assets.goal.com/images/v3/bltdfc9bbeb367b8917/Snapinsta.app_54510824_674393166324999_9009297382608007356_n_1080_%281%29.jpg?auto=webp&format=pjpg&width=3840&quality=60" class="img-fluid" style="border-radius: 5px; height: 125px;" alt="Alex Alcalá"/>
                        </a>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
           
        </div>
        
    </div>
</div>
`
  ];

  // 1️⃣ Build template (left visible structure, but hidden via gc_hidden; right side empty)
  useEffect(() => {
    if (clickedIndex === "" || clickedIndex == null) return;

    setIsLoading(true);
    setBaseHTML("");
    setOverviewText("");

    const html = fullHTML[clickedIndex];

    // Fallback: if DOMParser not available, just render everything
    if (typeof window === "undefined" || typeof window.DOMParser === "undefined") {
      setBaseHTML(html);
      setIsLoading(false);
      return;
    }

    const parser = new window.DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // 👉 grab overview content and clear it in template
    const overviewEl = doc.querySelector(".player-overview");
    let inner = "";

    if (overviewEl) {
      inner = overviewEl.innerHTML; // the text we’ll type
      overviewEl.innerHTML = "";    // start empty
    }

    // 👉 LEFT-SIDE: mark blocks as hidden, we'll fade them in via JS
    const sourcesEl = doc.querySelector(".sources");
    if (sourcesEl) {
      sourcesEl.classList.add("gc_hidden");
    }

    const profileCardEl = doc.querySelector(".player-profile-card");
    if (profileCardEl) {
      profileCardEl.classList.add("gc_hidden");
    }

    const videosEl = doc.querySelector(".player_video_container");
    if (videosEl) {
      videosEl.classList.add("gc_hidden");
    }

    // Convert modified DOM back to HTML string
    const templateHTML = doc.body.innerHTML;

    setBaseHTML(templateHTML);
    setOverviewText(inner);
  }, [clickedIndex, setIsLoading]);

  // 2️⃣ Sequential fade-in for LEFT blocks (sources → profile → videos)
  useEffect(() => {
    if (!baseHTML) return;
    if (!containerRef.current) return;

    const root = containerRef.current;

    const sourcesEl = root.querySelector(".sources");
    const profileCardEl = root.querySelector(".player-profile-card");
    const videosEl = root.querySelector(".player_video_container");

    const timeouts = [];

    // Show sources immediately
    if (sourcesEl) {
      timeouts.push(
        setTimeout(() => {
          sourcesEl.classList.remove("gc_hidden");
          sourcesEl.classList.add("gc_fade_in_slow");
        }, 0)
      );
    }

    // Then profile card
    if (profileCardEl) {
      timeouts.push(
        setTimeout(() => {
          profileCardEl.classList.remove("gc_hidden");
          profileCardEl.classList.add("gc_fade_in_slow");
        }, 1000) // 0.5s later
      );
    }

    // Then videos
    if (videosEl) {
      timeouts.push(
        setTimeout(() => {
          videosEl.classList.remove("gc_hidden");
          videosEl.classList.add("gc_fade_in_slow");
        }, 3000) // 1s after start (tweak as you like)
      );
    }

    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [baseHTML]);

  // 3️⃣ Typewriter: fill .player-overview innerHTML inside existing DOM
useEffect(() => {
  if (!baseHTML || !overviewText) {
    if (baseHTML && !overviewText) {
      setIsLoading(false);
    }
    return;
  }

  let index = 0;
  let current = "";
  const speed = 3;      // typing speed per character (keep as you like)
  const startDelay = 2000; // 1 second delay before typing starts

  let intervalId;
  const timeoutId = setTimeout(() => {
    intervalId = setInterval(() => {
      current += overviewText[index] || "";
      index += 1;

      if (containerRef.current) {
        const overviewEl = containerRef.current.querySelector(".player-overview");
        if (overviewEl) {
          overviewEl.innerHTML = current;
        }
      }

      if (index >= overviewText.length) {
        clearInterval(intervalId);
        setIsLoading(false);
      }
    }, speed);
  }, startDelay);

  return () => {
    clearTimeout(timeoutId);
    if (intervalId) clearInterval(intervalId);
  };
}, [baseHTML, overviewText, setIsLoading]);

  return (
    <div className="container mt-5">
      <div
        ref={containerRef}
        className="typewriter-content"
        dangerouslySetInnerHTML={{ __html: baseHTML }}
      />
    </div>
  );
};

export default TypewriterEffectPlayerProfile;
